import controller from './timeout-warning-modal-controller';
import template from './timeout-warning-modal.html';

const TimeoutWarningComponent = {
    bindings: {
        resolve: '<'
    },
    controller,
    template
};

export default TimeoutWarningComponent;



// WEBPACK FOOTER //
// ./app/common/timeout-warning/timeout-warning-modal/timeout-warning-modal-component.js